import { Stack } from 'shared/mui/Stack/Stack';
import { formatInputInTz } from 'utils/date';

type Props = {
  periodFrom: number;
  timezone?: string | null;
};

export const CumulativeReportPeriodDateField: React.FC<Props> = ({ periodFrom, timezone }) => {
  return (
    <Stack alignItems="start" direction="column" flexWrap="nowrap">
      <span>{formatInputInTz(periodFrom, { timezone, format: 'dd.MM.yyyy' })}</span>
    </Stack>
  );
};
